import { env } from "./env";

/**
 * Feature Flags Configuration
 *
 * Centralized feature flags for enabling/disabling features
 * across the application based on environment variables.
 */
export const features = {
  /**
   * Enable ChatGPT FAQ chat widget
   * Controlled by VITE_ENABLE_CHAT environment variable (default: enabled)
   * Set VITE_ENABLE_CHAT=false to disable
   */
  get chatGptFaq() {
    return env.enableChat;
  },
} as const;

/**
 * Type for feature flags
 */
export type Features = typeof features;

/**
 * Check if a specific feature is enabled
 *
 * @param featureName - Name of the feature to check
 * @returns Whether the feature is enabled
 */
export function isFeatureEnabled(featureName: keyof Features): boolean {
  return features[featureName];
}
